export const SCORECARD_STATUS_GOALS_PREPARED = 'goals_prepared';
export const SCORECARD_STATUS_GOALS_APPROVED = 'goals_approved';
export const SCORECARD_STATUS_FEEDBACK_COLLECTED = 'feedback_collected';
export const SCORECARD_STATUS_FEEDBACK_REQUESTED = 'feedback_requested';
export const SCORECARD_STATUS_ACTIVE = 'active';
export const SCORECARD_STATUS_COMPLETED = 'completed';
export const SCORECARD_STATUS_DELETED = 'deleted';

export const FEEDBACK_REQUEST_GOAL_STATUS_PENDING = 'pending';
export const FEEDBACK_REQUEST_GOAL_STATUS_ACCEPTED = 'accepted';

export const SCORECARD_TEMPLATE_STATUS_PUBLISHED = 'published';

export const SHOW_SCORECARD_EDIT_CONTROLS = false;

export const FEEDBACK_NOT_REQUESTED_STATUSES = [
  SCORECARD_STATUS_ACTIVE,
  SCORECARD_STATUS_GOALS_PREPARED,
  SCORECARD_STATUS_GOALS_APPROVED,
];

export const SCORECARD_ACTION_ASSESSMENT_COMPLETE =
  'action_assessment_complete';
export const SCORECARD_ACTION_ASSESSMENT_REOPEN = 'action_assessment_reopen';
export const SCORECARD_ACTION_ASSESSMENT_REQUEST = 'action_assessment_request';
export const SCORECARD_ACTION_ASSESSMENT_RE_REQUEST =
  'action_assessment_re_request';
export const SCORECARD_ACTION_ASSESSMENT_STOPPED =
  'action_stop_feedback_gathering';
export const SCORECARD_ACTION_GOALS_CONFIRM = 'action_goals_confirm';
export const SCORECARD_ACTION_GOALS_APPROVE = 'action_goals_approve';
export const SCORECARD_ACTION_GOALS_REDRAFT = 'action_goals_redraft';
export const SCORECARD_ACTION_GOALS_IN_PROGRESS_REVERT =
  'action_in_progress_goals_revert';

export const SCORECARD_COMMON_GOAL_TYPE_REGULAR = 'regular';
export const SCORECARD_COMMON_GOAL_TYPE_CUSAT = 'common_cusat';
export const SCORECARD_GOAL_TYPE_CUSAT = 'cusat';
export const SCORECARD_GOAL_TYPE_METRIC = 'metric';

export const CALCULATE_SELF_ASSESSMENT_PARAMETER_TYPE =
  'goal:regular:include_self-assessment';

export const ALLOW_SCORECARD_OWNER_EDITS_PARAMETER_TYPE =
  'goal:regular:allow_owner_edit';

export const ALLOW_SCORECARD_METRIC_PM_OWNER_EDITS_PARAMETER_TYPE =
  'goal:metric:allow_pm_owner_edit';

export const ALLOW_SCORECARD_OWNER_EDIT_ACTUAL_FIELD_PARAMETER_TYPE =
  'goal:metric:allow_owner_edit_actual_field';

export const AUTO_ASSIGN_PM_REVIEWER_PARAMETER_TYPE =
  'goal:regular:auto_assign_pm_reviewer';

export const LIMIT_REVIEWERS_TO_EMPLOYEE_AND_PM_PARAMETER_TYPE =
  'goal:regular:limit_reviewers_to_employee_and_pm';

export const ALLOW_SCORECARD_COMMENT_PARAMETER_TYPE =
  'goal:regular:feedback:allow_comment';
export const ENABLE_SELF_ASSESSMENT_PARAMETER_TYPE =
  'goal:regular:enable_self-assessment';

export enum MetricFormat {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
  NUMBER = 'number',
}

export enum MetricPerformanceFactor {
  PRORATED = 'prorated',
  PIPELINE = 'pipeline',
  EXCELLENCE = 'excellence',
  REVENUE_NO = 'revenue_no',
  REVENUE_EX = 'revenue_ex',
  DM = 'dm',
  BILLABILITY = 'billability',
  INVERSE_PROPORTION = 'inverse_proportion',
}

export const MAX_GOALS_COUNT = 35;
export const MAX_SUBGOALS_COUNT = 35;
